import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  Navigate,
} from "react-router-dom";
import "./App.css";
import Navbar from "./components/Navbar";
import RootRoute from "./routes/RootRoute";
import Today from "./components/Today";
import MyArcs from "./components/MyChallenges";
import {
  SignedIn,
  SignedOut,
  SignInButton,
  UserButton,
} from "@clerk/clerk-react";
import BrowseChallenges from "./components/BrowseChallenges";
import { Arc, db } from "./services/db";
import { v4 as uuidv4 } from "uuid";
import { challenges } from "./utils/challenges";
import ChallengeDetails from "./components/ChallengeDetails";

export interface Challenge {
  arcId: string;
  name: string;
  category: string;
  timePeriod: string;
  habits: Array<any>;
}

// const challenges: Challenge[] = [
//   {
//     arcId: uuidv4(),
//     name: "Mini Saitama Workout",
//     category: "Fitness",
//     timePeriod: "7",
//     habits: [
//       "20 Push ups",
//       "20 Sit ups",
//       "20 Squats"
//     ]
//   },
//   {
//     arcId: uuidv4(),

//     name: "Weekend Warrior",
//     category: "Productivity",
//     timePeriod: "2",
//     habits: [
//       "Start your day with 20 minutes of chill meditation 🧘‍♀️",
//       "Map out your weekend tasks like a boss 📝",
//       "Dive deep into focused work sprints for an hour ⏱️",
//       "Sneak in short breaks for snacks and fun 🍔",
//       "Wrap up the day by reflecting on your wins 🏆"
//     ]
//   },
//   {
//     arcId: uuidv4(),

//     name: "Social Butterfly Challenge",
//     category: "Socializing",
//     timePeriod: "7",
//     habits: [
//       "Break the ice with a new convo buddy every day 💬",
//       "Mix and mingle at a happening social event 🎉",
//       "Catch up with an old pal for some good vibes 🤗",
//       "Join a cool club or group hangout 🌟",
//       "Spread good vibes with a big ol' thank-you 🙏"
//     ]
//   },
//   {
//     arcId: uuidv4(),

//     name: "Chill Out and Relax",
//     category: "Mental Wellness",
//     timePeriod: "14",
//     habits: [
//       "Zen out with 15 minutes of mindful meditation daily 🧘‍♂️",
//       "Breathe easy with calming deep breaths 🌬️",
//       "Chill and watch thoughts float by without stress 🛋️",
//       "Get some fresh air and nature vibes 🌳",
//       "Take a tech break and unplug for a bit 📵"
//     ]
//   },
//   {
//     arcId: uuidv4(),

//     name: "Attitude of Gratitude",
//     category: "Personal Development",
//     timePeriod: "21",
//     habits: [
//       "Jot down 3 things you're grateful for every day 📝",
//       "Share the love and show appreciation to someone special ❤️",
//       "Reflect on the positive stuff and lessons learned 🌈",
//       "Boost yourself up with positive self-talk 🚀",
//       "Send out a heartfelt thank-you note 💌"
//     ]
//   },
//   {
//     arcId: uuidv4(),

//     name: "Weekend Adventure Time",
//     category: "Adventure",
//     timePeriod: "2",
//     habits: [
//       "Go on an epic hike or outdoor adventure ⛰️",
//       "Try something new and exciting outdoors 🚴‍♂️",
//       "Explore a cool new spot in town or nearby 🗺️",
//       "Check out some artsy stuff at a museum or gallery 🖼️",
//       "Hit up a fun cultural festival or event 🎭"
//     ]
//   },
//   {
//     arcId: uuidv4(),

//     name: "Daily Personal Brand Boost",
//     category: "Personal Branding",
//     timePeriod: "30",
//     habits: [
//       "3 Tweets daily 📸",
//       "Engage with at least three industry influencers or thought leaders on social media 🤝",
//       "Write and share a short blog post on a topic relevant to your personal brand 💡",
//       "Update your LinkedIn profile with recent accomplishments or projects 📝",
//       "Record a short video sharing a tip or advice related to your expertise 🎥",
//       "Reach out to a potential mentor or connection in your field for a virtual coffee chat ☕"
//     ]
//   }
//   // Add more challenges as needed
// ];

function App() {
  // const [arcs, setArcs] = useState<Arc[]>([]);

  //   useEffect(() => {
  //     fetchArcs();
  //   }, []);

  //   const fetchArcs = async () => {
  //     try {
  //       const allArcs = await db.getAllArcs(); // Call getAllArcs function to retrieve all arcs
  //       console.log('a:: ', arcs);
  //       setArcs(allArcs); // Set the arcs state with the retrieved arcs
  //     } catch (error) {
  //       console.error("Error fetching arcs:", error);
  //     }
  //   };

  return (
    <div className="App h-screen" data-theme="cupcake">
      {/* <header>
        <SignedOut>
          <SignInButton />
        </SignedOut>
        <SignedIn>
          <UserButton />
        </SignedIn>
      </header> */}
      <Router>
        <Routes>
          {/* <Route path="/" element={<RootRoute />} /> */}
          <Route
            path="/"
            element={<Navigate to="/browsechallenges" replace={true} />}
          />

          <Route element={<RootRoute />}>
            <Route
              path="/browsechallenges/:challengeId"
              element={<ChallengeDetails />}
            />
          </Route>

          <Route element={<RootRoute />}>
            <Route path="/today" element={<Today />} />
          </Route>

          <Route element={<RootRoute />}>
            <Route path="/myarcs" element={<MyArcs />} />
          </Route>

          <Route element={<RootRoute />}>
            <Route
              path="/browsechallenges"
              element={<BrowseChallenges challenges={challenges} />}
            />
          </Route>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
